module.exports = __webpack_public_path__ + "static/media/muslim_ny.b6eda85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/muslim_ny.jpg
// module id = 427
// module chunks = 0